<template>
		<div></div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
		name: 'ImpersonateLogin',
		methods: {
				...mapActions(['set_active_item'])
		},
		created() {
				let token = this.$route.params.token
				localStorage.setItem("auth-token", JSON.stringify(token))
				this.$router.push({
						name: 'Dashboard',
				}).catch(() => true);
				this.set_active_item(1);
		},
}
</script>
